import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;


export const PopupRoot = styled.div`
  cursor: default;
  input[type="checkbox"]:not(:disabled) {
    cursor: pointer;
  }
  input[type="checkbox"]:disabled {
    cursor: not-allowed;
  }
  .add-edit-invoice__image-view-icon:hover {
    cursor: default;
  }
`;

export const SummaryRows = styled.div`
  max-height: 26rem;
  overflow-y: scroll;
  display: flex;
  width: 100%;
  flex-direction: column;
  box-sizing: border-box;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 1.375rem 1.375rem;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 1rem 1.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const CaptionWrapper = styled.div`
  display: flex;
  alignitems: center;
  gap: 6px;
`;

export const CaptionColor = styled.span`
  width: 14px;
  height: 14px;
  min-width: 14px;
  border-radius: 40%;
  margin-top: 3px;
  background: ${(props) => props.color ?? "#474747"};
`;

export const SummaryHeader = styled.div`
  width: 100%;
  padding-right: var(--scrollbar-width, 0px);
  box-sizing: border-box;
`;